import { Button } from 'src/components/Button/Button';

import styles from './styles.module.scss';

type ErrorStateProps = {
  message?: string;
  onRetry?: () => void;
};

export const ErrorState = ({ message, onRetry }: ErrorStateProps) => (
  <div className={styles.wrapper}>
    <h1 className={styles.title}>Ой, щось пішло не так...</h1>
    <p className={styles.text}>
      Меню тимчасово недоступне. Спробуйте оновити сторінку або зайдіть пізніше.
    </p>
    {message && <code className={styles.errorMessage}>{message}</code>}
    <Button
      label="Оновити сторінку"
      onClick={onRetry ?? (() => window.location.reload())}
    />
  </div>
);
